import colors from './colors';

export default {
  color: colors.interaction
};
